import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import OrderUpdateHeader from './OrderUpdateHeader';

// Layout for the confined "update billing info" page. The user is authenticated
// (valid Cognito session + a resolved Salesforce Contact) but gets NO dashboard
// chrome. A non-Portal-Enabled contact who logs in through here can only ever see
// this page — MainLayout bounces them back here if they try to reach other routes
// by changing the URL.
function OrderUpdateLayout({ children }) {
    const { isOrderUpdateAuthenticated } = useAuth();
    const [authenticated, setAuthenticated] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const location = useLocation();

    useEffect(() => {
        let active = true;
        const checkAuth = async () => {
            setLoaded(false);
            try {
                const value = await isOrderUpdateAuthenticated();
                if (active) setAuthenticated(value);
            } catch {
                if (active) setAuthenticated(false);
            } finally {
                if (active) setLoaded(true);
            }
        };
        checkAuth();
        return () => {
            active = false;
        };
    }, [location.pathname]);

    if (!loaded) {
        return null;
    }

    if (authenticated) {
        return (
            <Box display="flex" flexDirection="column" minHeight="100vh">
                <OrderUpdateHeader />
                <Box component="main" flex={1}>
                    {children}
                </Box>
            </Box>
        );
    }

    // Not logged in yet: hand off to the existing /signout -> /login -> OTP chain,
    // preserving this path so the user lands back here after verifying.
    return (
        <Navigate
            to={'/signout' + (location.search || '') + (location.hash || '')}
            state={{
                path: location.pathname + (location.search || '') + (location.hash || ''),
                query: (location.search || '') + (location.hash || ''),
            }}
        />
    );
}

export default OrderUpdateLayout;
